import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Slide } from '../animate';
import classNames from 'classnames';
import './Toast.scss';
import { Info, Warning, Success, Error, Close } from '../../assets/icons/index';
import useTheme from '../../hooks/useTheme';
import { useSelector } from 'react-redux';

let activeToastCancel = null;

const Toast = (props) => {
	const types = {
		normal: null,
	};

	const { color, FontFace } = useTheme('LIGHT');

	// const onClick = (event) => {
	//   props.onCancel(event);
	// };

	/** 
	This effect runs only once when the toast mounts.
  	It dismisses any currently active toast and then registers this toast as active.
	*/
	useEffect(() => {
		if (activeToastCancel && activeToastCancel !== props.onCancel) {
		activeToastCancel();
		}
		activeToastCancel = props.onCancel;

		return () => {
		if (activeToastCancel === props.onCancel) {
			activeToastCancel = null;
		}
		};
	}, []);


	useEffect(() => {
		if (props.isVisible) {
			const timeoutId = setTimeout(() => {
				props.onCancel();
			}, 5000);

			// Cleanup the timeout when the component unmounts or when isVisible becomes false
			return () => clearTimeout(timeoutId);
		}
	}, [props.isVisible, props.onCancel]);

	const handleDismiss = () => {
		// Manually trigger the onCancel function when the cross button is clicked
		props.onCancel();
	};

	const announcementBannerClose = useSelector(
		(state) => state.announcementBannerCloseTrigger.announcementBannerClose
	);

	const maintenanceInstances = useSelector(
		(state) => state.maintenanceInstanceList.maintenanceInstances
	);
	const msg = maintenanceInstances?.data?.notification_msg;

	return (
		<>
			<Slide
				in={props.isVisible}
				timeout={{ enter: 50, exit: 250 }}
				mountOnEnter={true}
				unmountOnExit={true}
				appear={true}
			>
				<div
					className={classNames('Toast', props.containerClass)}
					style={{
						backgroundColor:
							props.messageType === 'info'
								? color.alert.background_violet
								: props.messageType === 'warning'
								? color.alert.background_warning
								: props.messageType === 'success'
								? color.alert.background_success
								: color.alert.background_error,
						border:
							props.messageType === 'info'
								? `1px solid ${color.alert.text_violet}`
								: props.messageType === 'warning'
								? `1px solid ${color.alert.text_warning}`
								: props.messageType === 'success'
								? `1px solid ${color.alert.text_success}`
								: `1px solid ${color.alert.text_error}`,
						marginTop : (msg && !announcementBannerClose) > 0 ? '32px' : '0px',
					}}
				>
					{types[props.messageType]}
					<div
						className="Toast__body flex"
						style={{
							color:
								props.messageType === 'info'
									? color.alert.text_violet
									: props.messageType === 'warning'
									? color.alert.text_warning
									: props.messageType === 'success'
									? color.alert.text_success
									: color.alert.text_error,
						}}
					>
						<span>
							{props.messageType === 'info' ? (
								<Info
									className="Toast__icon mr-9"
									width="17"
									height="17"
								/>
							) : props.messageType === 'warning' ? (
								<Warning
									className="Toast__icon mr-9"
									width="17"
									height="17"
								/>
							) : props.messageType === 'success' ? (
								<Success
									className="Toast__icon mr-9"
									width="17"
									height="17"
								/>
							) : props.messageType === 'error' ? (
								<Error
									className="Toast__icon mr-9"
									width="17"
									height="17"
								/>
							) : null}
						</span>
						{/* <span
							style={{
								fontSize: FontFace.font_size.small,
								fontWeight: FontFace.font_weight.medium,
							}}
						>
							{props.messageType === 'info' ? (
								<p>Info:&nbsp;</p>
							) : props.messageType === 'warning' ? (
								<p>Warning:&nbsp;</p>
							) : props.messageType === 'success' ? (
								<p>Success:&nbsp;</p>
							) : props.messageType === 'error' ? (
								<p>Error:&nbsp;</p>
							) : null}
						</span> */}

						<p
							style={{
								fontSize: FontFace.font_size.small,
								fontWeight: FontFace.font_weight.medium,
							}}
							className={classNames(props.messageClass)}
						>
							<span
								style={{
									fontWeight: FontFace.font_weight.bold,
								}}
							>
								{props.title}
							</span>
							{<span>{props.title ? ': ' : ''}</span>}
							{props.message}
						</p>
						<span style={{margingLeft:'4px', cursor:'pointer'}} onClick={handleDismiss}>
						<Close width="18" height="18"  />
					</span>
					</div>
				</div>
			</Slide>
		</>
	);
};

Toast.propTypes = {
	messageType: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
	isVisible: PropTypes.bool,
	showCloseButton: PropTypes.bool,
	message: PropTypes.string,
	onCancel: PropTypes.func,
	messageClass: PropTypes.string,
	containerClass: PropTypes.string,
	title: PropTypes.string,
	timeout: PropTypes.number,
};

Toast.defaultProps = {
	messageType: 'warning',
	message: '',
	title: '',
	isVisible: false,
	showCloseButton: true,
	onCancel: () => {},
	messageClass: '',
	containerClass: '',
	timeout: 2000,
};

export default Toast;
